import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

import introFlowersDesktop from './img/intro290desktop-flowers-0C09C83C-CCC6-4BE2-9D58-38C33CFEB3DB.png'
import introOrnamentDesktop from './img/intro290desktop-ornament-78FBC3F4-317A-400C-A2E9-D2E3D63710E7.png'
import introPetalWaterColorDesktop from './img/intro290desktop-petal-watercolor-C3B84070-7A1C-4124-B418-00BA75DAB604.png'
import introFlowersMobile from './img/intro290mobile-flowers-84AACD96-344E-4611-A84F-F98900556899.png'
import introOrnamentMobile from './img/intro290mobile-ornament-9C379C71-DD65-4A9F-A497-35C831C2545F.png'
import introPetalWaterColorMobile from './img/intro290mobile-petal-watercolor-8DB0222B-E916-4C3C-905E-4E583C03EE81.png'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const day = new Date(weddingDate.timestamp)
    .getDate()
    .toString()
    .padStart(2, '0')
  const month = new Intl.DateTimeFormat(locale, { month: '2-digit' })
    .format(new Date(weddingDate.timestamp))
    .toUpperCase()
  const year = new Date(weddingDate.timestamp).getFullYear()

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro290">
      <div className="intro290mobile screen">
        <div className="main-background-73ySXY">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <div className="container-center-horizontal">
          <div className="button-73ySXY">
            <p
              className="site-de-casamento-e-O8bIfs"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-O8bIfs" onClick={onSkipIntro}>
              <div className="button-MOQ5mp"></div>
              <div className="pular-introduo-MOQ5mp">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="container-wrapper">
          <div className="container-center-horizontal">
            <img
              className="ornament-73ySXY bp2-animate-enter2"
              src={introOrnamentMobile}
            />
          </div>

          <div className="container-center-horizontal">
            <div className="notranslate couple-name-73ySXY bp2-animate-enter1">
              {coupleSingleName.bride}{' '}
              {coupleSingleName.groom && (
                <>
                  <br />
                  &amp; {coupleSingleName.groom}
                </>
              )}
            </div>
          </div>

          <div className="container-center-horizontal">
            <div className="date-73ySXY bp2-animate-enter">
              {day}/{month}/{year}
            </div>
          </div>
        </div>
        <img
          className="petal-watercolor-73ySXY"
          src={introPetalWaterColorMobile}
        />
        <img className="flowers-73ySXY" src={introFlowersMobile} />
      </div>
      <div className="intro290desktop screen">
        <div className="main-background-37otsz bp1-animate-enter">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <div className="container-center-horizontal">
          <div className="button-37otsz">
            <p
              className="site-de-casamento-e-gVh6Fh"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="button-gVh6Fh" onClick={onSkipIntro}>
              <div className="button-Ohm9qw"></div>
              <div className="pular-introduo-Ohm9qw">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <img className="flowers-37otsz" src={introFlowersDesktop} />
        <img
          className="petal-watercolor-37otsz"
          src={introPetalWaterColorDesktop}
        />
        <div className="container-wrapper">
          <div className="container-center-horizontal">
            <img
              className="ornament-37otsz bp1-animate-enter3"
              src={introOrnamentDesktop}
            />
          </div>
          <div className="container-center-horizontal">
            <h1 className="notranslate couple-name-37otsz bp1-animate-enter2">
              {coupleSingleName.bride}{' '}
              {coupleSingleName.groom && (
                <>
                  <br />
                  &amp; {coupleSingleName.groom}
                </>
              )}
            </h1>
          </div>
          <div className="container-center-horizontal">
            <div className="date-37otsz bp1-animate-enter1">
              {day}/{month}/{year}
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
